import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { NgOtpInputModule } from 'ng-otp-input';
import { DateFormatPipe } from 'src/app/shared/pipes/date-format.pipe';
import { InvoiceStatusPipe } from 'src/app/shared/pipes/invoice-status.pipe';
import { AccountSetupComponent } from './components/account-setup/account-setup.component';
import { CustomTooltipComponent } from './components/custom-tooltip/custom-tooltip.component';
import { HomeComponent } from './components/home/home.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { LoginComponent } from './components/login/login.component';
import { NavmenuComponent } from './components/navmenu/navmenu.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { BulkUploadIconsComponent } from './components/bulk-upload-icons/bulk-upload-icons.component';
import { CustomTooltipDirective } from './directives/custom-tooltip.directive';
import { CustomValidatorDirective } from './validations/custom-validator.directive';

const routes: Routes = [
  { path: 'login', component: LoginComponent }, // login for admin user
  { path: 'complete-account-setup', component: AccountSetupComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
];

@NgModule({
  declarations: [
    InvoiceStatusPipe,
    DateFormatPipe,
    LoginComponent,
    NavmenuComponent,
    LandingPageComponent,
    CustomValidatorDirective,
    UserProfileComponent,
    PaginationComponent,
    HomeComponent,
    CustomTooltipComponent,
    CustomTooltipDirective,
    AccountSetupComponent,
    ResetPasswordComponent,
    BulkUploadIconsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    RouterModule.forChild(routes),
    MatTooltip,
  ],
  exports: [
    CustomValidatorDirective,
    InvoiceStatusPipe,
    DateFormatPipe,
    PaginationComponent,
    HomeComponent,
    NavmenuComponent,
    CustomTooltipComponent,
    CustomTooltipDirective,
    MatTooltip,
    BulkUploadIconsComponent,
  ],
})
export class SharedModule { }
